var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "advisor-search-tile" }, [
    _c(
      "div",
      { staticClass: "row mb-md-3 mb-2 ml-xs-3 mr-xs-3 ml-md-4 mr-md-4" },
      [
        _c("ci-user-tile", {
          staticClass: "w-100 bg-white col-12",
          attrs: {
            user: _vm.advisor,
            withSendMessage: false,
            withProfileLink: false,
            size: _vm.avatarSize,
            paddingClass: _vm.paddingClass,
            displayTileName: true,
            advisorTile: true,
          },
          scopedSlots: _vm._u([
            {
              key: "custom-location",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "advisor-search-tile__location d-flex",
                      class: _vm.fontClass,
                    },
                    [
                      _c("div", { staticClass: "d-flex" }, [
                        _vm.postcode
                          ? _c("p", {
                              staticClass: "text-dark m-0 mb-md-3 mr-2",
                              domProps: { textContent: _vm._s(_vm.postcode) },
                            })
                          : _vm._e(),
                        _vm.city
                          ? _c("p", {
                              staticClass: "text-dark m-0 mb-md-3 mr-2",
                              domProps: { textContent: _vm._s(_vm.city) },
                            })
                          : _vm._e(),
                      ]),
                      _vm.shouldDisplayDistance
                        ? _c("div", { staticClass: "d-flex" }, [
                            _c("div", {
                              staticClass: "mdi mdi-map-marker text-dark mr-2",
                            }),
                            _c("p", {
                              staticClass: "text-dark",
                              domProps: { textContent: _vm._s(_vm.distance) },
                            }),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "extra-content",
              fn: function () {
                return [
                  _c("div", { staticClass: "flex-grow-1 h-100 mt-3 mt-sm-0" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center h-100 justify-content-lg-center",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _vm._l(_vm.services, function (service) {
                              return _c("ci-tag", {
                                key: service.id,
                                staticClass:
                                  "text-sm no-hover d-flex align-items-center mb-2 mr-2",
                                attrs: {
                                  variant: "text",
                                  styleVariant: "light",
                                  tag: service.title,
                                  tagName: service.title,
                                },
                              })
                            }),
                            _vm.advisor.advisory_services.length >
                            _vm.numberOfTags
                              ? _c("ci-tag", {
                                  staticClass:
                                    "text-sm no-hover d-flex align-items-center mb-2 mr-2",
                                  attrs: {
                                    variant: "text",
                                    styleVariant: "light",
                                    tag: _vm.moreServices(),
                                    tagName: _vm.moreServices(),
                                  },
                                })
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "go-to-user",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "flex-grow-1 h-100 mt-3 mt-lg-0" },
                    [
                      _c(
                        "ci-router-link",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-center justify-content-xl-end h-100 font-weight-semi cursor-pointer text-nowrap",
                          class: _vm.fontClass,
                          attrs: { to: _vm.advisor.url },
                        },
                        [
                          _c("span", { staticClass: "mdi mdi-arrow-right" }),
                          _c("span", {
                            staticClass: "ml-2",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("ui.shared.go_to.user")
                              ),
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }